import { createContext, useContext, type PropsWithChildren } from "react";
import { useMemoryAuth } from "hooks/useMemoryAuth";

interface AuthContextType {
  token: string | null;
  login: (jwt: string) => void;
  logout: () => void;
  isAuthenticated: boolean;
  status: "loading" | "authenticated" | "unauthenticated";
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const auth = useMemoryAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

//this is a consumer actually, which is then called by other components.
//other components could use directly the AuthContext.
//this is a convenient function
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }

  return context;
};
